<template>
  <Dialog
    v-model="visible"
    class="provider-consent-dialog"
    title="Provider Consent"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
  >
    <p class="provider-consent-description">
      I understand that the tests have established reference ranges for adults (≥18 years of age)
      and that pediatric reference ranges have not been established for certain tests. I acknowledge
      that I may order the test, and I am responsible for interpreting results based on the clinical
      evaluation of a pediatric individual.
    </p>

    <div class="consent-radio-group">
      <div class="consent-radio-item" @click="select('yes')">
        <span class="radio-circle" :class="{checked: selection==='yes'}"></span>
        <span>Yes, I consent.</span>
      </div>
      <div class="consent-radio-item" @click="select('no')">
        <span class="radio-circle" :class="{checked: selection==='no'}"></span>
        <span>No, I do not consent.</span>
      </div>
      <div class="consent-checkbox-wrap">
        <Checkbox
          :status="selection==='yes' && skipPediatricConsent ? 'checked' : 'uncheck'"
          @changeStatus="onSkipPediatricConsent"
        >
          Yes, and never ask again.
        </Checkbox>
      </div>
    </div>

    <div class="dob-dashed"></div>

    <div class="continue-btn-wrapper">
      <Button
        type="normal"
        colorType="dark-blue"
        :disabled="!selection"
        @click="onContinue"
      >
        Continue
      </Button>
    </div>
  </Dialog>
</template>

<script>
import Dialog from '@/NewLibrary/Dialog.vue'
import Button from '@/NewLibrary/Button.vue'
import Checkbox from '@/NewLibrary/Checkbox.vue'

export default {
  name: 'ProviderConsentDialog',
  components: { Dialog, Button, Checkbox },
  props: { modelValue: { type: Boolean, default: false } },
  emits: ['update:modelValue', 'submit'],
  data() {
  return { selection: null, skipPediatricConsent: false }
  },
  computed: {
    visible: {
      get() { return this.modelValue },
      set(v) { this.$emit('update:modelValue', v) }
    }
  },
  watch: {
    visible(v) { 
      if (v) { 
        this.selection = null; 
        this.skipPediatricConsent = false; 
      } 
    }
  },
  methods: {
    select(val) {
      if (val === 'yes' && this.selection === 'yes' && this.skipPediatricConsent) {
        this.selection = null;
        this.skipPediatricConsent = false;
      } else if (this.selection === val) {
        this.selection = null;
        if (val === 'yes') this.skipPediatricConsent = false;
      } else {
        this.selection = val;
        if (val !== 'yes' && this.skipPediatricConsent) {
          this.skipPediatricConsent = false;
        }
      }
    },
    onSkipPediatricConsent(status) {
      if (status === 'checked') {
        this.selection = 'yes';
        this.skipPediatricConsent = true;
      } else {
        this.skipPediatricConsent = false;
      }
    },
    onContinue() {
      if (!this.selection) return
      const accepted = this.selection === 'yes'
      this.visible = false
      this.$emit('submit', {
        accepted,
        skipPediatricConsent: this.skipPediatricConsent
      })
    }
  }
}
</script>

<style scoped>
.consent-radio-group {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin: 12px 0 20px;
}
.consent-radio-item {
  display: grid;
  grid-template-columns: 18px 1fr;
  align-items: center;
  column-gap: 12px;
  cursor: pointer;
  font-size: 15px;
  margin-left: 190px;
  user-select: none;
}
.consent-radio-item span {
  color: #333333;
}
.consent-checkbox-wrap {
  display: flex;
  align-items: center;
  margin-left: 185px;
  font-size: 15px;
  user-select: none;
}
.radio-circle {
  width: 18px;
  height: 18px;
  border: 1px solid #1E4670;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #fff;
}
.radio-circle.checked::after {
  content: '';
  display: block;
  width: 10px;
  height: 10px;
  background: #1E4670;
  border-radius: 50%;
}
.dob-dashed {
  border-bottom: 1px dashed #C8CDD3;
  height: 0;
  margin-top: 6px;
}
.provider-consent-description {
  color: var(--Text-text-primary, #161616);
  text-align: justify;
  font-family: "IBM Plex Sans Hebrew";
  word-break: break-word;
  font-size: 15px;
  line-height: 20px;
  letter-spacing: 0.25px;
}
.continue-btn-wrapper {
  display: flex;
  justify-content: center;
  margin-top: 16px;
}
</style>
